var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSeenIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.508,
    height: 8.22,
    viewBox: "0 0 11.508 8.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eye-svgrepo-com",
    d: "M1.5,8.61C1.5,7.377,3.555,4.5,7.254,4.5s5.754,2.877,5.754,4.11-2.055,4.11-5.754,4.11S1.5,9.843,1.5,8.61Zm5.754,2.6a2.6,2.6,0,1,0-2.6-2.6A2.6,2.6,0,0,0,7.254,11.213Zm1.48-2.6a1.48,1.48,0,1,1-1.48-1.48,1.48,1.48,0,0,1,1.48,1.48Z",
    transform: "translate(-1.5 -4.5)",
    fill: "#058728",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSeenIcon);
export default __webpack_public_path__ + "static/media/message-seen-icon.a1dcd40bb60849f05ef90d313d4c345d.svg";
export { ForwardRef as ReactComponent };